/** Catalog control-plane login bounce (Chat is not an IdP). */

export function getCatalogLoginUrl() {
  return (import.meta.env.VITE_CATALOG_LOGIN_URL ?? '').trim()
}

export function isCatalogSsoEnabled() {
  return Boolean(getCatalogLoginUrl())
}

export function getCatalogProductCode() {
  return (import.meta.env.VITE_CATALOG_PRODUCT_CODE ?? 'chat').trim() || 'chat'
}

/** True while Catalog handoff `?code=` is present (must not bounce to Catalog). */
export function hasCatalogHandoffCode(search = typeof window !== 'undefined' ? window.location.search : '') {
  try {
    return Boolean(new URLSearchParams(search).get('code')?.trim())
  } catch {
    return false
  }
}

/** Full Catalog sign-in URL with product + return_to for SSO bounce. */
export function buildCatalogSignInUrl(returnPath = '/', origin = typeof window !== 'undefined' ? window.location.origin : '') {
  const base = getCatalogLoginUrl()
  if (!base) return ''
  const path = returnPath.startsWith('/') ? returnPath : `/${returnPath}`
  const returnTo = `${origin}${path}`
  const url = new URL(base)
  url.searchParams.set('product', getCatalogProductCode())
  url.searchParams.set('return_to', returnTo)
  return url.toString()
}

/**
 * Bounce to Catalog login. No-op while `?code=` is present — bouncing mid-handoff
 * remints forever (Catalog already logged in). See auth.chat.architecture.md §5.1.1.
 */
export function redirectToCatalogLogin(returnPath = '/', search = typeof window !== 'undefined' ? window.location.search : '') {
  if (hasCatalogHandoffCode(search)) return
  const href = buildCatalogSignInUrl(returnPath)
  if (href) window.location.assign(href)
}
